// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"18":"24d59d48","454":"b971ea31","504":"36c33586"}[chunkId] + ".js";
};